// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__QrB4a","overlayClick":"style_overlayClick__bUEpx","closebtn":"style_closebtn__8RDQx","overlay-content":"style_overlay-content__6vOTt"};